import { inject } from 'inversify'
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { ListEventTicketsInputDto } from '../../domain/dtos/tickets/list-event-tickets-input.dto'
import { Envs } from '../../envs'
import { GeneralError } from '../../domain/errors/general'
import { Cohort } from '../../domain/dtos/member-area/get-associated-cohorts-response'
import { OrderDirection } from '../../domain/dtos/orderDirection'

export class ListEventTicketsUsecase {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<Cohort[]>,
  ) {}

  public async execute(input: ListEventTicketsInputDto): Promise<Cohort[] | undefined> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input.productId}/cohorts/list-event-tickets`,
      params: {
        orderDirection: input.orderDirection ?? OrderDirection.DESC,
        orderBy: input.orderBy ?? 'createdAt',
      },
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response?.data
    }

    throw new GeneralError()
  }
}
